module.exports = __webpack_public_path__ + "static/media/loading.42fe18db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/loading.svg
// module id = 2729
// module chunks = 0